<template>
  <f7-page name="ccm-examset-apply" class="page-bg-render">
    <f7-navbar>
      <div class="title">
				<span v-if="mode=='ANSWER'">답안입력</span>
        <span v-else>채점결과</span>
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>
			<div class="display-flex">
				<div>
					<span>코드 : {{examSetInfo.EXAMSET_CODE}}</span><br/>
					<span>제목 : {{examSetInfo.EXAMSET_NAME}}</span>
				</div>
				<div style="align-self: flex-end; margin-left: auto;">
					<a href="#" @click="toggleViewMode()">
						<span v-if="viewMode=='ANSWER-VIEW'">문제보기</span>
						<span v-else>답란보기</span>
					</a>
				</div>
			</div>
		</f7-block-title>

		<template v-if="viewMode=='ANSWER-VIEW'">
			<div class="list">
				<ul v-if="answers.length">
					<li v-for="(exam, i) in answers" :key="'i' + i">
						<obj-input v-if="exam.answerType == 'obj'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></obj-input>
						<sbj-input v-else-if="exam.answerType == 'sbj'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></sbj-input>
						<des-input v-else-if="exam.answerType == 'des'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></des-input>
					</li>
				</ul>
				<p v-else class="text-align-center padding-vertical" v-on:click="test">로딩중...</p>
			</div>
			<div class="block">
				<div class="row">
					<div class="left"></div>
					<div class="right">
						<button class="button button-fill" v-on:click="submitButtonClick" v-if="mode == 'ANSWER'">답안제출</button>
						<span class="txt-color-primary" v-else>답안 제출이 완료 되었습니다.</span>
					</div>
				</div>
			</div>
		</template>
		<template v-if="viewMode=='EXAM-VIEW'">
			<div class="block block-strong">
				<img :src="getExamImgUrl()" width="100%" style="margin-bottom:10px;"/>
				<img v-if="isNeedObjectImg()" :src="getObjectiveImgUrl()" width="100%"/>
			</div>
			<div class="block"><!-- SCROLL SAFE BLOCK --></div>
			<div class="toolbar toolbar-bottom" style="position:absolute; height:auto; color:unset;">
				<div class="list no-margin-vertical">
					<ul>
						<li>
							<div class="item-content item-inner">
								<div class="row" style="width:100%">
									<div class="col-50">
										<button class="button button-outline inline-btn" @click="movePrevExam()" :class="{ disabled: (examViewExamIndex <= 0) }">이전</button>
										<button class="button button-outline inline-btn" @click="moveNextExam()" :class="{ disabled: (examViewExamIndex >= (answers.length -1)) }">다음</button>
									</div>
									<div class="col-50 text-align-right">
										<button class="button button-fill inline-btn" @click="submitButtonClick" v-if="mode == 'ANSWER'">답안제출</button>
										<span class="txt-color-primary" v-else>답안제출 완료.</span>
									</div>
								</div>
							</div>
						</li>
						<li v-if="getExamType() == 'obj'">
							<obj-input :seqIndex="examViewExamIndex" :examNo="(examViewExamIndex+1)" :key="forceRenderId"></obj-input>
						</li>
						<li v-else-if="getExamType() == 'sbj'">
							<sbj-input :seqIndex="examViewExamIndex" :examNo="(examViewExamIndex+1)" :key="forceRenderId"></sbj-input>
						</li>
						<li v-else-if="getExamType() == 'des'">
							<des-input :seqIndex="examViewExamIndex" :examNo="(examViewExamIndex+1)" :key="forceRenderId"></des-input>
						</li>
					</ul>
				</div>
			</div>
		</template>
    
  </f7-page>
</template>

<script>
  import Vue from 'vue';
	import { f7 } from 'framework7-vue';
	import store from '../../../../js/store';

	import MODULE from '../../../../js/common/module';
	import AUTH from '../../../../js/common/auth.js';
	import PAGES from '../../../../js/pages';
	import API from '../../../../js/common/api.js';
	import CONST from '../../../../js/common/constant';

	import ObjInput from '../../../../components/answer/obj-input';
	import SbjInput from '../../../../components/answer/sbj-input';
	import DesInput from '../../../../components/answer/des-input';
  
	export default {
		components: {
			ObjInput,
			SbjInput,
			DesInput,
		},
    data() {
      return {
				forceRenderId: 1,
				viewMode: "ANSWER-VIEW",
				mode: "ANSWER",
				examViewExamIndex: 0,

				studyType: "",
				examSetKey: 0,
				studyKey: 0,
				studyResultKey: 0,

				examSetInfo: {},
				answers: []
      }
		},
		mounted() {
			var _this = this;

			_this.studyType = _this.$f7route.context.studyType;
			_this.examSetKey = _this.$f7route.context.examSetKey;
			_this.studyKey = _this.$f7route.context.studyKey;
			_this.studyResultKey = _this.$f7route.context.studyResultKey;

			setTimeout(function() {
				if (_this.studyType == "exam-sdy") {
					if (_this.examSetKey != undefined) {
						_this.loadExamSetSelfStudyInfo();
					} else if (_this.studyResultKey != undefined) {
						_this.loadExamSetApplyResult();
					}
				} else if (_this.studyType == "exam-put") {					
					if (_this.studyResultKey != undefined) {
						_this.loadExamSetApplyResult();
					} else if (_this.studyKey != undefined) {
						_this.loadExamSetHomeworkInfo();
					}
				}
			}, 300);			
		},
    methods: {
			toggleViewMode() {
				if (this.viewMode == 'ANSWER-VIEW') {
					this.viewMode = 'EXAM-VIEW';
				} else {
					this.viewMode = 'ANSWER-VIEW';
				}
			},
			movePrevExam() {
				if (this.examViewExamIndex > 0) {
					this.examViewExamIndex--;
				}
			},
			moveNextExam() {
				if (this.examViewExamIndex < (this.answers.length-1)) {
					this.examViewExamIndex++;
				}
			},
			isNeedObjectImg() {
				var answerItem = this.answers[this.examViewExamIndex];
				if (answerItem.answerType == "obj") {
					return true;
				}

				return false;
			},
			getExamType() {
				var answerItem = this.answers[this.examViewExamIndex];
				return answerItem.answerType;
			},
			getExamImgUrl() {
				var answerItem = this.answers[this.examViewExamIndex];
				var imgUrl = MODULE.Util.getExamPrintImgUrl(answerItem.examKey, answerItem.answerType, "exam");

				return imgUrl;
			},
			getObjectiveImgUrl() {
				var answerItem = this.answers[this.examViewExamIndex];
				var imgUrl = MODULE.Util.getExamPrintImgUrl(answerItem.examKey, answerItem.answerType, "objective");

				return imgUrl;
			},
			loadExamSetInfo(url, param) {
				var _this = this;

        API.ajaxRequest({
					url: url,
					data: param
				}).then(function (data) {

					var commonObj = store.getters.commonObj;
					commonObj.mode = "ANSWER";
					commonObj.examSetInfo = data.examSetInfo;
					commonObj.answers = data.answers;
					_this.mode = commonObj.mode;
					_this.examSetInfo = commonObj.examSetInfo;
					_this.answers = commonObj.answers;

				}).catch(function (code) {
					if (code == CONST.resultCode.EMPTY) {
						PAGES.back();
						MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다. 코드를 확인하세요.");
						return;
					}
					
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			loadExamSetSelfStudyInfo() {
				var _this = this;

				var url = API.getExamSetSelfStudyInfoUrl();

				let param = {
					pExamSetKey : _this.examSetKey
				};

				_this.loadExamSetInfo(url, param);
			},
			loadExamSetHomeworkInfo() {
				var _this = this;

				var url = API.getExamSetHomeworkInfoUrl();

				let param = {
					pStudyKey : _this.studyKey
				};

				_this.loadExamSetInfo(url, param);
			},
			loadExamSetApplyResult() {
				var _this = this;
				
				/*
				let param = {
					pStudyResultKey : _this.studyResultKey
				};
				*/
				let param = {
					pStudyKey : _this.studyKey
				};

        API.ajaxRequest({
					url: API.getExamSetApplyResultUrl(),
					data: param
				}).then(function (data) {

					var commonObj = store.getters.commonObj;

					commonObj.mode = "SCORE";
					commonObj.examSetInfo = data.examSetInfo;
					commonObj.answers = data.answers;

					_this.mode = commonObj.mode;
					_this.examSetInfo = commonObj.examSetInfo;
					_this.answers = commonObj.answers;
					_this.examSetCode = commonObj.examSetInfo.EXAMSET_CODE;

					_this.forceRenderId++;
					
				}).catch(function (code) {
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			test() {
				var _this = this;

				var commonObj = store.getters.commonObj;
				commonObj.mode = "SCORE";
				commonObj.examSetInfo = {
					EXAMSET_NAME : "테스트"
				};
				commonObj.answers = [
					{
						answerType: "obj",
						correct: "o",
						lectures: [
							{
								lectureCode: "L3",
								lectureType: "e-otl",
								lectureLevel: "hintdef",
								blockOrder: 1
							},
							{
								lectureCode: "L4",
								lectureType: "e-img",
								lectureLevel: "hint1",
								blockOrder: 2
							},
							{
								lectureCode: "L3",
								lectureType: "b-mp4",
								lectureLevel: "hint2",
								blockOrder: 3
							},
							{
								lectureCode: "L3",
								lectureType: "e-img",
								lectureLevel: "lecdef",
								blockOrder: 4
							},
							{
								lectureCode: "L4",
								lectureType: "e-mp4",
								lectureLevel: "lec1",
								blockOrder: 5
							},
							{
								lectureCode: "L3",
								lectureType: "e-otl",
								lectureLevel: "lec2",
								blockOrder: 5
							},
						],
						answer: "2.4",
						inputAnswer: "2.4"
					},
					{
						answerType: "sbj",
						correct: "x",
						lectures: [
							{
								lectureCode: "L3",
								lectureType: "e-otl",
								lectureLevel: "hintdef",
								blockOrder: 1
							},
							{
								lectureCode: "L3",
								lectureType: "e-img",
								lectureLevel: "hint1",
								blockOrder: 2
							},
							{
								lectureCode: "L3",
								lectureType: "b-mp4",
								lectureLevel: "hint2",
								blockOrder: 3
							},
							{
								lectureCode: "L3",
								lectureType: "e-img",
								lectureLevel: "lecdef",
								blockOrder: 4
							},
							{
								lectureCode: "L3",
								lectureType: "e-mp4",
								lectureLevel: "lec1",
								blockOrder: 5
							},
							{
								lectureCode: "L3",
								lectureType: "e-otl",
								lectureLevel: "lec2",
								blockOrder: 5
							},
						],
						subExamList: [
							{
								subNoDisplay: "(1)",
								answerInputList: [
									{
										answerType: "s-obj",
										info: "객관형-안내문구",
										answer: "3.5",
										inputAnswer: "3.5"
									},
									{
										answerType: "s-sbj",
										info: "주관형-안내문구",
										unit: "$$cm$$",
										answerList: [
											"AAA",
											"BBB",
											"CCC"
										],
										inputAnswer: "가나다 $$ax^2$$ 소리"
									},
									{
										answerType: "s-sel",
										info: "선택형-안내문구",
										answer: "2.3",
										inputAnswer: "2.3",
										exampleList: [
											"AAA 가나다라 가나다라 가나다라 가나다라 가나다라 가나다라 가나다라",
											"BBB",
											"CCC",
											"DDD"
										]
									},
									{
										answerType: "s-mat",
										info: "짝짓기형-안내문구",
										answer: "13.21.32",
										inputAnswer: "13.21.32",
										leftExampleList: [
											"AAA",
											"BBB",
											"CCC"
										],
										rightExampleList: [
											"AAA",
											"BBB",
											"CCC"
										]
									},
									{
										answerType: "s-form",
										info: "빈칸형-안내문구",
										form: "‌$$ax+{\\textcolor{red}{\\Box}}={\\textcolor{red}{\\Box}}$$‌ + ‌##FORM-BOX##",
										answerList: [
											"23",
											"사과",
											"abc"
										],
										inputAnswerList: [
											"23",
											"사과",
											"abc"
										],
									},
								]
							},
							{
								subNoDisplay: "(2)",
								answerInputList: [
									{
										answerType: "s-obj",
										info: "객관형-안내문구",
										answer: "3.5",
										inputAnswer: "3.5"
									},
									{
										answerType: "s-sbj",
										info: "주관형-안내문구",
										unit: "$$km$$",
										answerList: [
											"AAA",
											"BBB",
											"CCC"
										],
										inputAnswer: "AAA"
									}
								]
							},
						]
					},
					{
						answerType: "obj",
						correct: "o",
						lectures: [
							{
								lectureCode: "L3",
								lectureType: "e-otl",
								lectureLevel: "hintdef",
								blockOrder: 1
							},
							{
								lectureCode: "L3",
								lectureType: "e-img",
								lectureLevel: "hint1",
								blockOrder: 2
							},
							{
								lectureCode: "L3",
								lectureType: "b-mp4",
								lectureLevel: "hint2",
								blockOrder: 3
							},
							{
								lectureCode: "L3",
								lectureType: "e-img",
								lectureLevel: "lecdef",
								blockOrder: 4
							},
							{
								lectureCode: "L3",
								lectureType: "e-mp4",
								lectureLevel: "lec1",
								blockOrder: 5
							},
							{
								lectureCode: "L3",
								lectureType: "e-otl",
								lectureLevel: "lec2",
								blockOrder: 5
							},
						],
						answer: "3.4",
						inputAnswer: "2.4"
					},
				];

				_this.mode = commonObj.mode;
				_this.examSetInfo = commonObj.examSetInfo;
				_this.answers = commonObj.answers;
			},
			saveExamSetResult(url, param) {
				var _this = this;

				var result = MODULE.Util.checkValidateAnswers(param.pAnswers);
				
				var message = "";
				if (result.code != "OK") {					
					if (result.code == "EMPTY-ANSWER") {
						message = "비어있는 정답이 있습니다.<br/>조건에 맞지 않는 문항은 오답처리 됩니다.<br/>그래도 제출 할까요 ?";
					} else if (result.code == "OVERFLOW-LENGTH") {
						message = "정답이 너무 길어 잘리는 문항이 있습니다.<br/>잘린 문항은 오답처리 됩니다.<br/>그래도 제출 할까요 ?";
					}
				} else {
					message = "정답을 전송하고나면 변경할 수 없습니다.<br/>제출할까요 ?";
				}

				MODULE.DialogBox.okcancel(
					"정답 제출 확인", message,
					function() {	// on OK.

						API.jsonRequest({
							url: url,
							data: param
						}).then(function (data) {

							if(data.point != undefined){
								MODULE.DialogBox.message("알림", "획득 포인트 :" + data.point);
							}

							var commonObj = store.getters.commonObj;
							commonObj.mode = "SCORE";
							commonObj.answers = data.answers;

							_this.mode = commonObj.mode;
							_this.answers = commonObj.answers;

							_this.forceRenderId++;
						}).catch(function (code) {
							MODULE.UITool.catchBlock(code, PAGES, AUTH);
						});
					}
				);
			},
			submitButtonClick() {
				var _this = this;

				var answers = store.getters.commonObj.answers;

				if (_this.studyType == "exam-sdy") {
					var url = API.saveExamSetSelfStudyUrl();
					var param = {
						pExamSetKey : _this.examSetKey,
						pAnswers: answers
					};

					_this.saveExamSetResult(url, param);
				} else if (_this.studyType == "exam-put") {
					var url = API.saveExamSetHomeworkUrl();
					var param = {
						pStudyKey : _this.studyKey,
						pAnswers: answers
					};

					_this.saveExamSetResult(url, param);
				}

			},
    }
  }

</script>